import { render, staticRenderFns } from "./CompTabelaErrosProtesto.vue?vue&type=template&id=703f6204&"
import script from "./CompTabelaErrosProtesto.vue?vue&type=script&lang=js&"
export * from "./CompTabelaErrosProtesto.vue?vue&type=script&lang=js&"
import style0 from "./CompTabelaErrosProtesto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports